module.exports = __webpack_public_path__ + "static/raptor_edit_v3-0a951c6f22fb10ce6fee273b0b12823e.mp4";